import styles from './Select.module.scss';
import { SelectSize } from './types';

export const sizeClass: Record<SelectSize, string> = {
    lg: styles.selectBox_field_size_lg,
    md: styles.selectBox_field_size_md,
    xs: styles.selectBox_field_size_xs,
};

export const SELECT_ID_LENGTH = 6;
